// extracted by mini-css-extract-plugin
module.exports = {"header":"NewMember_header__pQ_Qe flex_header__QIaoO","wrapper":"NewMember_wrapper__H78Xv flex_wrapper__qR0T3","headTitle":"NewMember_headTitle__UpARw flex_headTitle__e_A__"};